import styled, { css } from 'styled-components';
import { CustomSelect as SelectView } from '../../select/select-modal/styles';
const centered = css `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const defaultButtonSize = css `
  width: 3.2rem;
  height: 3.2rem;
`;
export const CustomSelect = styled(SelectView) `
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};

  && {
    background-color: ${({ theme, isFiltered }) => isFiltered
    ? theme.colors.interactive.brandColor
    : theme.colors.surface.default};

    svg {
      display: none;
    }
  }

  && {
    ${({ theme }) => {
    const backColor = theme.colors.surface
        .interactiveDefault;
    const radius = theme.borderRadius
        .medium;
    return theme.media.tablet `
        padding: 1rem 1.8rem;
        height: 5.4rem;

        margin-left:0;

        border-radius: ${radius};

        background-color:${backColor};

        &:not(:last-child) {
          margin-right: 1.6rem;
        }
        
      
        svg{
          display:block;
        }
      `;
}};
  }
`;
export const CalendarWrapper = styled.div `
  .react-calendar__navigation__prev-button {
    padding-bottom: 0.5rem;
    padding-right: 0.6rem;
    font-size: 2.5rem !important;
  }

  .react-calendar__navigation__next-button {
    padding-bottom: 0.5rem;
    padding-left: 0.9rem;
    font-size: 2.5rem !important;
  }
`;
export const LabelWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const IconWrapper = styled.div `
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
  padding: 0 0.8rem;
  display: none;

  ${({ theme }) => theme.media.tablet `
    display: block;
  `}
`;
export const DatesWrapper = styled.div `
  display: flex;
  margin: 1.2rem 0 2rem;
`;
export const DatesSeparator = styled.div `
  width: 1.2rem;
`;
export const CalendarStyle = css `
  .react-calendar__navigation__label {
    pointer-events: none;
  }
  .react-calendar__navigation__label__labelText {
    font-size: 1.6rem;
    line-height: 2.4rem;
    pointer-events: none;
    cursor: default;
    font-family: ${({ theme }) => theme.fonts.primaryBold};
    color: ${({ theme }) => theme.colors.text.default};
  }

  & button {
    border: none;
    background: none;
  }
  & .react-calendar__viewContainer {
    padding: 0 2.2rem;
    font-size: 1.4rem;
    line-height: 2rem;
    font-family: ${({ theme }) => theme.fonts.primaryBold};

    button {
      padding: 0;
      margin-top: 1.2rem;
    }

    .react-calendar__tile--range {
      background: ${({ theme }) => theme.colors.interactive.secondary};
    }

    .react-calendar__tile--rangeBothEnds {
      &::after {
        display: none;
      }
    }

    .react-calendar__tile--rangeStart,
    .react-calendar__tile--rangeEnd {
      background: none;
      position: relative;
      z-index: 1;
      &::after {
        content: '';
        width: 50%;
        height: 100%;
        z-index: -1;
        position: absolute;
        right: 0;
        background: ${({ theme }) => theme.colors.interactive.secondary};
      }
    }
    .react-calendar__tile--rangeEnd {
      background: none;
      z-index: 1;
      &::after {
        left: 0;
        right: unset;
      }
    }

    .react-calendar__tile--rangeStart abbr,
    .react-calendar__tile--rangeEnd abbr {
      background: ${({ theme }) => theme.colors.interactive.brandColor};
      border-radius: 50%;

      ${defaultButtonSize}
      ${centered}
      color: ${({ theme }) => theme.colors.text.interactive} !important
    }

    .react-calendar__month-view__days__day,
    .react-calendar__month-view__weekdays__weekday {
      ${defaultButtonSize}
      ${centered}
    }
    .react-calendar__month-view__days__day {
      abbr {
        color: ${({ theme }) => theme.colors.text.default};
      }

      &:disabled abbr {
        color: ${({ theme }) => theme.colors.text.disabled};
      }
    }

    .react-calendar__month-view__weekdays__weekday abbr {
      text-decoration: none;
      font-family: ${({ theme }) => theme.fonts.primary};
      color: ${({ theme }) => theme.colors.text.default};
    }

    .react-calendar__month-view__weekdays {
      pointer-events: none;
      /* margin-bottom: 1.2rem; */
    }
  }

  .react-calendar__navigation__arrow {
    cursor: pointer;
  }

  .react-calendar__tile {
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }

  & .react-calendar__navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: default;

    padding: 1.4rem 0.8rem;
    border: 1px solid ${({ theme }) => theme.colors.borders.default};
    border-left: 0;
    border-right: 0;

    .react-calendar__navigation__next2-button,
    .react-calendar__navigation__prev2-button {
      display: none !important;
    }

    .react-calendar__navigation__arrow {
      ${defaultButtonSize}
      font-size: 2.2rem;
      color: ${({ theme }) => theme.colors.text.default};

      ${centered}

      border-radius: ${({ theme }) => theme.borderRadius.highest};
      background: ${({ theme }) => theme.colors.surface.interactiveDefault};
    }
  }
`;
export const ActionsSeparator = styled.div `
  width: 1.1rem;
  height: 1.1rem;
`;
export const ActionsWrapper = styled.div `
  display: flex;
  margin-top: 2rem;
  flex-direction: column;
  ${({ theme }) => theme.media.tablet `
    flex-direction: row;
  `}
`;
export const ExactDayToggleWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 4.2rem;
  padding: 0 1.4rem;
  border-radius: 0.6rem;
  background: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;
export const EmptyDiv = styled.div ``;
export const CloseIconWrapper = styled.div `
  width: fit-content;
  padding: 1.1rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
`;
export const CalendarTitle = styled.div `
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.tablet `
  display:flex;
  `};
`;
//# sourceMappingURL=styles.js.map